import styled from 'styled-components/macro'

export const CustomCheckbox = styled.label`
  &.checkbox-container {
    top: 25px;
    left: 0px;
    display: block;
    position: relative;
    padding-left: 35px;
    cursor: pointer;
    font-size: 22px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  &.checkbox-container input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 20px;
    width: 20px;
    background-color: transparent;
    border: solid 1px #ccc;
  }

  &.checkbox-container input:checked ~ .checkmark {
    background-color: #1f2f3b;
  }

  .checkmark:after {
    content: '';
    position: absolute;
    display: none;
  }

  &.checkbox-container input:checked ~ .checkmark:after {
    display: block;
  }

  &.checkbox-container .checkmark:after {
    left: 7px;
    top: 3px;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }
`
